import React from 'react';
import { withErrorBoundary } from '@/utils/errors';
import styles from './ForbiddenWebpage.module.scss';
import Link from 'next/link';

const FourOhFour = () => {
  return (
    <div className={styles.FourOhFourBack}>
      <p className={styles.FourOhFourBackText}>404 - Page Not Found</p>
      <Link href="/" className={styles.FourOhFourBackLink}>
        Go back home
      </Link>
    </div>
  );
};

export default withErrorBoundary(FourOhFour);
